/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IEditArena, IEditArenaInterface } from "../IEditArena";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "editArena",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IEditArena__factory {
  static readonly abi = _abi;
  static createInterface(): IEditArenaInterface {
    return new utils.Interface(_abi) as IEditArenaInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IEditArena {
    return new Contract(address, _abi, signerOrProvider) as IEditArena;
  }
}
